import FlaskIcon from '~/components/icons/FlaskIcon.jsx';

const ExperimentalBadge = ({ className }) => {
    return (
        <div
            className={`text-[#947AAF] bg-[#F3F0F6] rounded-full px-3 py-1.5 font-medium text-[10px] uppercase  flex items-center ${className}`}
        >
            <FlaskIcon className="w-3 h-3 mr-2" />
            Experimental
        </div>
    );
};

export default ExperimentalBadge;
